import user from '@/store/modules/user';
import checkout from '@/store/modules/checkout';
import cart from '@/store/modules/cart';
import {CartResponse, QuoteAddress} from '@/store/models';
import addressNormalizer from '@/commons/addressNormalizer';
import app from '@/store/modules/app';
import {bus} from './bus';

const event = 'cart.received';

export default event;

bus.$on(event, (cartModel: CartResponse) => {
    app.changeCartItemNumber();
    if (cartModel.customer && cartModel.customer.email) {
        user.setCustomer(cartModel.customer);
        checkout.setEmail(cartModel.customer.email);
    } else if (cartModel.extension_attributes.extcustomer_email) {
        checkout.setEmail(cartModel.extension_attributes.extcustomer_email);
    }

    if (cartModel.billing_address && cartModel.billing_address.id) {
        checkout.setBillingAddress(addressNormalizer(cartModel.billing_address) as QuoteAddress);
    }

    const shippingAssignmentAddress = cart.shippingAssignementAddress;
    const shippingAssignment = cart.shippingAssignement;

    if (shippingAssignmentAddress) {
        checkout.setShippingAddress(addressNormalizer(shippingAssignmentAddress) as QuoteAddress);
    }

    if (shippingAssignment && shippingAssignment.shipping && shippingAssignment.shipping.method) {
        checkout.setSelectedShipment(shippingAssignment.shipping.method);
    }
});
